import { Typography } from '@mui/material'
import React from 'react'

const Paragraphboxed = ({ text, maxWidth, mx, textAlign }) => {
  return (
    <Typography
    sx={{
      maxWidth: maxWidth,
      paddingTop: '20px',
      paddingBottom: '20px',
      mx: mx,
      textAlign: textAlign,
      py: 5,
      color: '#ffffff',
      fontSize: "2em",
      fontFamily:'League Spartan sans-serif',
      fontWeight: 600,
      '@media (max-width:420px)': {
        fontSize: '1.2em',
        lineHeight:'1.2'
        
      }    }}
    >
        {text}
    </Typography>
  )
}

export default Paragraphboxed